import { ORDER_MANAGER_API_URL } from '@hcs/urls';

export const ORDER_MANAGER_WEB_SOCKET_URL = `${
  window.location.protocol === 'http:' ? 'ws:' : 'wss:'
}//${ORDER_MANAGER_API_URL.split('://', 2)[1]}/ws`;
